import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../components/common/Layout';
import { Paper, Typography, Box, Stack } from '@mui/material';
import QRCode from 'react-qr-code';
import Button from '../components/common/Button';
import useOptionConfig from '../hooks/useOptionConfig';

const TestSuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { config } = useOptionConfig();
  const labels = config?.labels?.testSuccessPage || {};
  const qrCodeValue = location.state?.qrCode;

  const handleDownload = () => {
    const svg = document.getElementById("QRCode");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.download = "test-qr-code.png";
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  if (!qrCodeValue) {
    return (
      <Layout>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" color="error">{labels.noQrData || "No QR Code data found."}</Typography>
          <Typography>{labels.goBackMsg || "Please go back and create a test first."}</Typography>
          <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate('/create-test')}>
            {labels.backToCreate || "Back to Create Test"}
          </Button>
        </Paper>
      </Layout>
    );
  }

  return (
    <Layout>
      <Paper sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
        <Typography variant="h4" color="primary">{labels.successTitle || "Test Created Successfully!"}</Typography>
        <Box sx={{ p: 2, bgcolor: (theme) => theme.palette.background.paper }}>
          <QRCode id="QRCode" value={qrCodeValue} size={256} />
        </Box>
        <Typography variant="body1">{labels.scanInstructions || "Scan the QR code to view the test."}</Typography>
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" onClick={handleDownload}>{labels.downloadQr || "Download QR"}</Button>
          <Button variant="contained" onClick={() => navigate('/analysis')}>{labels.finish || "Finish"}</Button>
        </Stack>
      </Paper>
    </Layout>
  );
};

export default TestSuccessPage;